The formatted name of a person, as it would be written out together.

This field is redacted and a static 'redacted' text is returned when a candidate or job application is deleted.
This redaction is limited to candidate data objects within SEEK optimized apply.
